<template>
  <SGPRowComponent>
    <div class="pl-5">
      <div class="container-dados-usuario" v-if="!loadingFichaTecnica">
        <div class="grid">
          <InformacoesCircuitoComponent
            :dadosFichaTecnica="dadosFichaTecnica"
            :podeVisualizarFichaCompleta="podeVisualizarFichaCompleta"
          />
          <InformacoesClienteComponent
            :dadosFichaTecnica="dadosFichaTecnica"
            :podeVisualizarFichaCompleta="podeVisualizarFichaCompleta"
            @emitAbrirModalContato="$emit('emitAbrirModalClienteContato')"
          />
          <InformacoesTarefaComponent :dadosFichaTecnica="dadosFichaTecnica" />
          <StatusTarefaComponent :dadosFichaTecnica="dadosFichaTecnica" />
          
          <AgingComponent
              v-if="dadosFichaTecnica.pco_tarefa"
              :titulo="'Tarefa: '+dadosFichaTecnica.pco_tarefa.ctrl_tarefa.tarefa"
              :item="dadosFichaTecnica.pco_tarefa"
          />
          <AgingComponent
              v-if="dadosFichaTecnica.pco_tarefa.processo"
              :titulo="'Processo: '+dadosFichaTecnica.pco_tarefa.processo.ctrl_processo.processo"
              :item="dadosFichaTecnica.pco_tarefa.processo"
          />
          <AgingComponent
              v-if="dadosFichaTecnica.pco_tarefa.processo.macro_processo"
              :titulo="'Macro processo: '+dadosFichaTecnica.pco_tarefa.processo.macro_processo.ctrl_processo.processo"
              :item="dadosFichaTecnica.pco_tarefa.processo.macro_processo"
          />
          <InformacoesDadosSevComponent
              v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.pco_circuito_s_s_a"
              :pcoCircuitoSSA="dadosFichaTecnica.pco_tarefa.pco_circuito.pco_circuito_s_s_a"
              :numeroSev="dadosFichaTecnica.pco_tarefa.pco_circuito.numero_sev"
          />
          <template v-if="podeVisualizarFichaCompleta">
            <FichaPcoCircuitoComponent :dadosFichaTecnica="dadosFichaTecnica" />
          </template>

          <template v-if="dadosFichaTecnica.pco_tarefa.pco_circuito.fichas_tecnicas.length">
            <PcoCircuitoFichasTecnicasComponent :dadosFichaTecnica="getPcoCircuitoFichasTecnicas()" />
          </template>

          <template>
            <TarefasAbertasComponent :dadosFichaTecnica="dadosFichaTecnica" />
          </template>
        </div>
      </div>
      <SGPAlertaComponent v-else />
    </div>
  </SGPRowComponent>
</template>

<script>

import AgingComponent from '../AgingComponent'
import { formataDataBr } from '@/common/boot/Utils'
import InformacoesCircuitoComponent from './InformacoesCircuitoComponent'
import InformacoesClienteComponent from './InformacoesClienteComponent'
import InformacoesTarefaComponent from './InformacoesTarefaComponent'
import StatusTarefaComponent from './StatusTarefaComponent'
import FichaPcoCircuitoComponent from './FichaPcoCircuitoComponent'
import TarefasAbertasComponent from './TarefasAbertasComponent'
import InformacoesDadosSevComponent from './InformacoesDadosSevComponent'
import PcoCircuitoFichasTecnicasComponent from './PcoCircuitoFichasTecnicasComponent'


export default {
  name: "GridInformacoesComponent",
  components: {
    AgingComponent,
    InformacoesCircuitoComponent,
    InformacoesClienteComponent,
    InformacoesTarefaComponent,
    StatusTarefaComponent,
    FichaPcoCircuitoComponent,
    TarefasAbertasComponent,
    InformacoesDadosSevComponent,
    PcoCircuitoFichasTecnicasComponent
},
  props: {
    dadosFichaTecnica: {
      type: Array,
      required: true
    },

    loadingFichaTecnica: {
      type: Boolean,
      required: true
    },

    podeVisualizarFichaCompleta: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    formataDataBr,

    getPcoCircuitoFichasTecnicas() {
      if(this.dadosFichaTecnica.pco_tarefa.pco_circuito.fichas_tecnicas.length < 1) return []

      
      let obj = this.dadosFichaTecnica.pco_tarefa.pco_circuito.fichas_tecnicas[0];
      let dados = Object.entries(obj);
      dados = JSON.parse(dados[2][1]);
      dados = Object.entries(dados);

      console.log('Ficha tecnica: ', dados);

      dados.sort(function (a, b) {
        if (a[1].ordem > b[1].ordem) {
          return 1;
        }
        if (a[1].ordem < b[1].ordem) {
          return -1;
        }
        return 0;
      });

      return Object.fromEntries(dados);
    }
  }
}
</script>